import { render, staticRenderFns } from "./ApplicantTrackingDashboard.vue?vue&type=template&id=64a75c3f&scoped=true"
import script from "./ApplicantTrackingDashboard.vue?vue&type=script&lang=js"
export * from "./ApplicantTrackingDashboard.vue?vue&type=script&lang=js"
import style0 from "./ApplicantTrackingDashboard.vue?vue&type=style&index=0&id=64a75c3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a75c3f",
  null
  
)

export default component.exports